import { decode } from 'html-entities';

const Proofs = {
	
	name: 'Proofs',
	model: {

		idProperty: 'proofs__id',
		displayProperty: 'proofs__id',

		sorters: [
			{
				name: 'proofs__book_num',
				direction: 'ASC',
			},
			{
				name: 'proofs__chapter',
				direction: 'ASC',
			},
			{
				name: 'proofs__start_verse',
				direction: 'ASC',
			},
		],
		
		properties: [
			{ name: 'proofs__id',	mapping: 'id',	type: 'int', },
			{ name: 'proofs__question_id',	mapping: 'question_id',	type: 'int', },
			{ name: 'proofs__book',	mapping: 'book', },
			{ name: 'proofs__book_num',	mapping: 'proofs__book_num', type: 'int', },
			{ name: 'proofs__chapter',	mapping: 'chapter',	type: 'int', },
			{ name: 'proofs__start_verse',	mapping: 'start_verse',	type: 'int', },
			{ name: 'proofs__end_verse',	mapping: 'end_verse',	type: 'int', },

			// { name: 'questions__id',	mapping: 'question.id',	type: 'int', },
			// { name: 'questions__display_as',	mapping: 'question.display_as', },
			// { name: 'questions__q',	mapping: 'question.q', },
			// { name: 'questions__a',	mapping: 'question.a', },
			// { name: 'questions__next',	mapping: 'question.next',	type: 'int', },
			// { name: 'questions__prev',	mapping: 'question.prev',	type: 'int', },
			// { name: 'questions__next_in_full',	mapping: 'question.next_in_full',	type: 'int', },
			// { name: 'questions__sort_order',	mapping: 'question.sort_order',	type: 'int', },
			// { name: 'questions__division_id',	mapping: 'question.division_id',	type: 'int', },
			// { name: 'questions__volume_id',	mapping: 'question.volume_id',	type: 'int', },
			// { name: 'questions__ordinal',	mapping: 'question.ordinal', },
	
		],

		associations: {

			belongsTo: [
				'Questions'
			],

		},

	},

	entity: {
		methods: {

			getQuestion: function() {
				const Questions = this.getAssociatedRepository('Questions');
				return Questions.getById(this.proofs__question_id);
			},
			
			getSiblings: function() {
				return this.getQuestion().getProofs();
			},
			
			getString: function() {
				const strParts = [];
				if (this.proofs__book) {
					strParts.push(this.proofs__book + ' ');
				}
				if (this.proofs__chapter) {
					strParts.push(this.proofs__chapter);
					if (this.proofs__start_verse) {
						strParts.push(':');
					}
				}
				if (this.proofs__start_verse) {
					strParts.push(this.proofs__start_verse);
					if (this.proofs__end_verse) {
						strParts.push('&ndash;');
					}
				}
				if (this.proofs__end_verse) {
					strParts.push(this.proofs__end_verse);
				}
				return decode(strParts.join(''));
			},

		},
	},

	repository: {
		type: 'lfr',
		local: {
			type: 'async',
			isPaginated: false,
			autoSave: true,
		},
		remote: {
			type: 'onebuild',
			isPaginated: false,
			autoSave: false,
		},
	},

};

export default Proofs;
